import React from 'react';
//Stles
import containerStyles from './container.module.css';

export default ({ children, justifyContent }) => (
  <div className={`${containerStyles.root} ${containerStyles[justifyContent]}`}>
    {children}
  </div>
);
